export const LABEL_CLOSE_ICON_SIZE = 10;
export const LABEL_REMOVE_ALL_ICON_SIZE = 18;

export const AD_FEATURE_TABS_SCROLL_END_TOLERANCE = 10;
